import { TrendingDown } from "lucide-react";
import { RecordModule } from "@/components/RecordModule";
import { fmtNum } from "@/lib/format";

export default function CustomerLoss() {
  return <RecordModule name="customer-loss" icon={TrendingDown} subtitle="Losses caused by customer material quality / quantity delays"
    kpis={(s) => [
      { title: "Loss events", value: s?.count, sub: `${s?.customers ?? 0} customer(s)` },
      { title: "Total loss ₹", value: fmtNum(Math.round(s?.amount || 0)), status: s?.amount ? "red" : undefined, sub: "Sum of loss amount" },
      { title: "Open / unclaimed", value: s?.open, status: s?.open ? "amber" : "green", sub: "Not yet accepted / closed" },
      { title: "Top loss type", value: s?.by_group?.[0]?.group || "—", sub: s?.by_group?.[0] ? `${s.by_group[0].count} event(s)` : "" },
    ]} />;
}
